import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import { UiTextArea, BgLoader, UiButton, UiFindSelect, UiToggle } from "../ui";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useLocation } from "react-router-dom";




const Leadassign = NiceModal.create(
  ({ id }) => {
    const [state, setState] = useState({});
    const modal = useModal();
    const schema = yup.object().shape({
      no_lead: yup.boolean(),
      lead: yup
      .mixed()
      .nullable()
      .when("no_lead", {
        is: false,
        then: (rule) =>
          rule
            .required("This is required field"
            )
      }),



    });
    const {
      register,
      handleSubmit,
      control,
      watch,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });

    const onSubmitHandler = async (data) => {
      SaveData();
      //reset();
    };
    var SaveData = (e) => {
      setState({ ...state, loader: true });
      var form = document.querySelector("#leadmapform");
      var data = new FormData(form);

      instance({
        method: "post",
        url: "/z_lead_map",
        data: data,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
          setState({ ...state, loader: false });
          if (response.data.status == "error") {
            toast(response.data.msg, { type: "error" });
          }
          if (response.data.status == "success") {
            toast(response.data.msg, { type: "success" });
            modal.resolve({ resolved: true, rm_name: response.data.rm_name, rm_mobile: response.data.rm_mobile });
            modal.hide();
          }
        })
        .catch(function (response) { });
    };
    useEffect(() => {

     instance
        .get("/z_lead_map?id=" + id)
        .then(function (response) {
          if (response.data.status == 'success') {
            setState({ ...state, ...response.data });
            reset(response.data.item);
          } else {
            toast(response.data.msg, { type: "error" });
          }


        })
        .catch(function (error) {  })
        .then(function () { });

    }, []);

    const location = useLocation();
    useEffect(() => {
      if (modal.visible == true) {
        modal.hide();
      }
    }, [location]);

    const loadLeadOptions = (inputValue, callback) => {
      if (!inputValue || inputValue.length < 2) {
        callback([]);
        return;
      }

      instance
        .get("/z_get_leads?s=" + inputValue)
        .then(function (response) {
          if (response.data.status == 'success') {
            callback(response.data.items);
          } else {
            toast(response.data.msg, { type: "error" });
          }


        })
        .catch(function (error) { callback([]) })
        .then(function () { });


    };
    const watchNoLead = watch('no_lead');
    return (
      <BootstrapModal {...bootstrapDialog(modal)} >
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Map Lead</BootstrapModal.Title>
        </BootstrapModal.Header>
        {state && state.item ? 
        
        <form id="leadmapform" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
          <BootstrapModal.Body>


            <UiToggle
              id="mark_mapped"
              name="no_lead"
              title="This client has no lead"
              {...register("no_lead")}
            />


            <Controller
              name="lead"
              control={control}
              render={({ field }) => (

                <UiFindSelect
                  isDisabled={watchNoLead}
                  className=""
                  loadOptions={loadLeadOptions}
                  message={errors.lead?.message}
                  label="Lead"
                  cacheOptions
                  {...field}
                />

              )}
            />


            <input type="hidden" name="id" {...register("id")}></input>




          </BootstrapModal.Body>
          <BootstrapModal.Footer>
            <UiButton loading={state["loader"]} title="Save" />
            <a className="btn btn-secondary" onClick={modal.hide}>Cancel</a>
          </BootstrapModal.Footer>
        </form>
          : <BgLoader />}
      </BootstrapModal>
    );
  }
);

export default Leadassign;
